import { IFsFileType } from "@r3f-component-data-structure";
import { FsBaseFile } from "./base";
export class FsAudio extends FsBaseFile {
    type = IFsFileType.Audio;
    _cdnUrl;
    constructor(fileId, projectId, name) {
        super(fileId, projectId, name);
        const url = new URL(this.baseUrl);
        url.pathname = `${url.pathname}/aud.mp3`;
        this._cdnUrl = url.toString();
    }
    async getUrl() {
        return this.fs.getObjectUrl(this._cdnUrl, await this.getBlob());
    }
    async getBlob() {
        return this.fs.getFileBlob(this._cdnUrl);
    }
    async getFilesForBundler() {
        const blob = await this.getBlob();
        return [{
                path: `fs/${this.id}/aud.mp3`,
                bin: new Uint8Array(await blob.arrayBuffer())
            }];
    }
}
